import React from 'react';

import { Button } from '../../../../elements';
import { logout } from '../../../../components/auth/redux/authActions';
import { webhookActions } from '../../../../redux/reducers/webhook';
import { useAppDispatch } from '../../../../hooks/useRedux';
import { showError, showSuccess } from '../../../../elements/Toasts/toastActions';
import FileInput from '../../../../elements/FileInput/FileInput';
import ModalContainer from '../../../../elements/ModalContainer/ModalContainer';
import CertificateUploadFile from '../../../../components/Certificate/CertificateUploadFile';
import strings from '../../../../lang/lang';

interface IModal {
  closeModal: (v?: object) => any;
}

function UploadCertificate(props: IModal) {
  const { closeModal } = props;
  const dispatch = useAppDispatch();

  function uploadCertificate(file) {
    if (file && file[0]) {
      return new Promise((res, rej) => {
        dispatch(webhookActions.uploadWebhookCertificate({ attachments: { file: file[0] }, res, rej }));
      })
      .then(() => {
        showSuccess(strings.appWebhookDetails.text.successUploadCertificate);
      })
      .catch(({ data, status }) => {
        if (401 === status) {
          logout();
        } else {
          let errorMessage;
          if (data.message === 'CertificateModificationException') {
            errorMessage = 'Invalid certificate file';
          } else if (data.message === 'Maximum active certificates count reached!') {
            errorMessage = 'Maximum number of certificates was reached. Please remove existing certificate before uploading.';
          } else {
            errorMessage = data.message;
          }
          showError(strings.formatString(strings.appWebhookDetails.errors.savingCertificate, errorMessage));
        }
      })
      .finally(() => {
        closeModal({});
      });
    }
  }

  return (
    <ModalContainer
      isOpen
      closeModalWindow={() => closeModal({})}
      title={strings.appWebhookDetails.text.uploadTitle}
      header={strings.appWebhookDetails.text.uploadDescription}
    >
      <FileInput accept=".cer" noDrag={false} onDrop={(file) => uploadCertificate(file)}>
        <CertificateUploadFile />
      </FileInput>
      <Button
        name={strings.appWebhookDetails.buttons.cancel}
        variant="secondary"
        secondaryClassName="popup_secondary"
        onClick={() => closeModal({})}
      />
    </ModalContainer>
  );
}

export default UploadCertificate;
